module.exports = __webpack_public_path__ + "static/media/efrs_logo.d2c576a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/efrs_logo.svg
// module id = 1424
// module chunks = 33